import { resolveSupportEmail } from '../deployment';
import { ldsBrand } from './lds';
import { movantBrand } from './movant';
/**
 * The brands this build can render. Adding one is a new pack file here plus its
 * static files under the portal's `public/brand/<name>/` (logos, icons,
 * manifest) — nothing else names a brand.
 */
const BRAND_PACKS = {
    movant: movantBrand,
    lds: ldsBrand,
};
export const BRAND_NAMES = Object.keys(BRAND_PACKS);
/** The brand a deployment gets when it names none. */
export const DEFAULT_BRAND = 'movant';
function runtimeAppConfig() {
    return globalThis.__APP_CONFIG__;
}
function nonBlank(value) {
    return typeof value === 'string' && value.trim().length > 0 ? value.trim() : undefined;
}
/**
 * Which brand this deployment runs: the `brand` key the portal container's
 * entrypoint writes into /config.js (from the `BRAND` env var) when it names a
 * known pack, else the default. An unknown name falls back rather than throws —
 * a typo in a deployment's settings must not blank the page.
 */
export function resolveBrandName(runtime = runtimeAppConfig()) {
    const requested = nonBlank(runtime?.brand)?.toLowerCase();
    // Own keys only: `in` would also accept `constructor`, `toString`, ...
    const known = requested !== undefined && Object.prototype.hasOwnProperty.call(BRAND_PACKS, requested);
    return known ? requested : DEFAULT_BRAND;
}
/**
 * The full settings of one brand: its pack plus the deployment's support
 * address (../deployment.ts resolves it — runtime value, else the default).
 */
export function brandFor(name, runtime = runtimeAppConfig()) {
    const pack = BRAND_PACKS[name];
    return {
        ...pack,
        contact: { ...pack.contact, email: resolveSupportEmail(runtime) },
    };
}
